export { default as useUniversalFilterTextPlain } from './useUniversalFilterTextPlain';
